export default "__VITE_ASSET__95f9c576__"